import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import AuthPage from "@/pages/AuthPage";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AdminPanel from "@/pages/AdminPanel";
import AboutPage from "@/pages/AboutPage";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-petal-beige flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-petal-olive border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-outfit text-petal-muted">Loading...</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-petal-beige flex items-center justify-center">
      <div className="w-12 h-12 border-4 border-petal-olive border-t-transparent rounded-full animate-spin mx-auto"></div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const Layout = ({ children, hideFooter = false }) => (
  <>
    <Navbar />
    <main>{children}</main>
    {!hideFooter && <Footer />}
    <WhatsAppButton />
  </>
);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/shop" element={<Layout><ShopPage /></Layout>} />
      <Route path="/shop/:id" element={<Layout><ProductDetailPage /></Layout>} />
      <Route path="/cart" element={<Layout><CartPage /></Layout>} />
      <Route path="/checkout" element={<ProtectedRoute><Layout><CheckoutPage /></Layout></ProtectedRoute>} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/about" element={<Layout><AboutPage /></Layout>} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><CustomerDashboard /></Layout></ProtectedRoute>} />
      <Route path="/admin" element={<AdminRoute><Layout hideFooter><AdminPanel /></Layout></AdminRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
